<template>
	<!-- Vue Material MenuItem with custom confirm option -->
	<!-- https://vuematerial.io/components/menu -->

	<md-menu-item
		ref="menuitem"
		:class="{ 'ui-menu-item--confirm': showConfirm }"
		:disabled="disabled"
		class="ui-menu-item"
		v-on="$listeners"
		@click.capture.stop="click"
		@mouseleave="showConfirm = false"
	>
		<span class="ui-menu-item__label">{{ showConfirm ? confirmLabel || label : label }}</span>
		<i
			v-if="icon"
			:class="showConfirm ? confirmIcon || icon : icon"
			class="ui-menu-item__icon"
		></i>
		<md-tooltip v-if="tooltip">{{ tooltip }}</md-tooltip>
	</md-menu-item>
</template>

<script>
export default {
	name: "MenuItem",
	props: {
		confirm: {
			type: Boolean,
			default: false,
			required: false
		},
		confirmIcon: {
			type: String,
			default: null,
			required: false
		},
		confirmLabel: {
			type: String,
			default: "",
			required: false
		},
		disabled: {
			type: Boolean,
			default: false,
			required: false
		},
		icon: {
			type: String,
			default: null,
			required: false
		},
		label: {
			type: String,
			required: true
		},
		tooltip: {
			type: String,
			default: "",
			required: false
		}
	},
	data() {
		return {
			showConfirm: false
		};
	},
	methods: {
		click() {
			if (this.confirm && !this.showConfirm) {
				this.showConfirm = true;

				return;
			}

			this.showConfirm = false;
			this.$refs.menuitem.triggerCloseMenu();
			this.$emit("click");
		}
	}
};
</script>

<style lang="scss" scoped>
.ui-menu-item {
	&.ui-menu-item--confirm {
		background-color: #eb6b60;
		.ui-menu-item__icon,
		.ui-menu-item__label {
			color: #fff;
		}
	}
	i {
		&.fa,
		&.fas,
		&.far,
		&.fal {
			font-size: 22px;
		}
	}
}
</style>
